
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconCheck = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M23.374.287a1.5 1.5 0 00-2.093.345L7.246 20.2l-4.685-4.689a1.5 1.5 0 10-2.122 2.121l5.935 5.934a1.525 1.525 0 002.279-.186l15.066-21a1.5 1.5 0 00-.345-2.093z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M7.001 23.999a.5.5 0 01-.354-.147l-6.5-6.5a.5.5 0 01.708-.707l6.083 6.083L23.094.208a.503.503 0 01.697-.114c.109.078.18.193.202.325a.496.496 0 01-.087.373l-16.5 23a.501.501 0 01-.365.207h-.04z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M6.347 24.003a2.95 2.95 0 01-2.36-1.187L.15 17.7a.748.748 0 01.6-1.2c.235 0 .459.112.6.3l3.839 5.118a1.442 1.442 0 001.42.562c.381-.068.712-.281.933-.599L22.636.32a.748.748 0 111.228.86L8.772 22.739a2.93 2.93 0 01-1.9 1.217c-.173.031-.35.047-.525.047z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconCheck.displayName = 'IconCheck';
export default IconCheck;